import { render, staticRenderFns } from "./Intellectual.vue?vue&type=template&id=512fddb9&scoped=true"
import script from "./Intellectual.vue?vue&type=script&lang=js"
export * from "./Intellectual.vue?vue&type=script&lang=js"
import style0 from "./Intellectual.vue?vue&type=style&index=0&id=512fddb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512fddb9",
  null
  
)

export default component.exports